<template>
  <el-dialog
    custom-class="audit-show"
    title="选择审批"
    :visible.sync="visible"
    destroy-on-close
    width="766px"
  >
    <div class="flex overflow-auto h-96">
      <!-- 左半部分 -->
      <div class="select-user flex flex-1 flex-col px-6 overflow-auto box-border">
        <p class="text-medium-x font-semibold leading-22 text-theme-black-850 mb-4">已选用户</p>
        <article class="text-medium font-normal leading-24 bg-card-bg-gray px-4 py-3">
          <p class="text-theme-black-650">请从右侧选择审批人</p>
        </article>
        <ul class="overflow-y-auto pt-6">
          <li class="flex justify-between leading-22 h-9" v-for="(item, index) in disableList" :key="item.id">
            <span class="text-theme-black-650"
              >{{ item.name }}
              <span v-if="item.mobile && item.staffType !== 2" class="text-theme-black-650">({{ item.mobile }})</span></span
            >
            <span class="text-theme cursor-pointer" @click="onClickDelUser(index)">删除</span>
          </li>
        </ul>
      </div>
      <article class="w-px h-96">
        <p style="backgroundcolor: #e7e9eb; height: calc(100% - 6px)"></p>
      </article>
      <!-- 右半部分 -->
      <dygc-user
          class="flex-1"
          is-order
          disabled-raw-data
          :disabled-list="disabledList"
          :isSingle="isSingle"
          :multiple="multiple"
          :value="disableList"
          @input="getInputList"
          ref="dygcUser"
      />
    </div>

    <!-- <el-select v-else v-model="payerV" filterable placeholder="请选择">
      <el-option v-for="item in payerList" :key="item.id" :label="item.name + '-' + item.mobile" :value="item.id"> </el-option>
    </el-select> -->
    <span slot="footer" class="dialog-footer">
      <el-button class="normal-button" @click="cancel">取 消</el-button>
      <el-button class="normal-button" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
// import StepItem from './StepItem'
// import AvatarPerson from './AvatarPerson'
import DygcUser from '@/components/dygc-user/DygcUser'
import { getStaffForPay } from '@/api/wenjuan/settlement'
import { startAudit, cancelAudit } from '@/api/cost-settlement/settlement-initiate/submitStatement'
import { getApprovalDetailProcess } from '@/api/cost-settlement/myRelate'
import { statisticsDetail } from '@/api/cost-settlement/common'
import { AUDIT_STATUS, SETTLE_OBJ_TYPE } from '@/views/home/cost-settlement/settlement-initiate/settle-process/settleConst.js'
import GlobalConfig from '@/global/config'

let saveData = {}
export default {
  components: { DygcUser },
  data() {
    return {
      drawer: false,
      message: '',
      title: '审批',
      visible: false,
      disableList: [],
      isSingle: false,
      multiple: false,
      approver: [],
      payer: [],
      originator: [],
      companyId: GlobalConfig.getCompanyId(),
      payerList: [],
      payerV: '',
      // approverSave: [],
      payerSave: [],
      isCheck: false,
      approvalVisible: false,
      cancelApprovalVisible: false,
      auditStatus: null
    }
  },
  props: {
    // originator: {
    //   type: Array,
    //   default: () => []
    // }
    sid: {
      type: [String, null],
      default: null
    },
    disabledList:{
      type:Array,
      default: ()=>[]
    }
  },
  computed: {
    approverSave() {
      return (this.disableList??[]).map(item => ({ ...item, phone: item.mobile, deptName: (item.organs??[]).map(o => o.name).join(',') }))
    }
  },
  mounted() {
  },
  methods: {
    //确认发起
    getInputList(value) {
      // console.log('value',value)
      this.disableList = value
    },
    cancel() {
      this.visible = false
      this.approver = JSON.parse(JSON.stringify(this.approver))
    },
    confirm() {
      if (this.title === '审批') {
        this.approver = this.approverSave
        this.$emit('changeStaff',this.disableList )
      } else {
        //支付
        const one = this.payerList.find(item => item.id === this.payerV)
        this.payer = [{ ...one, phone: one.mobile, deptName: (one.organs??[]).map(o => o.name).join(',') }]
      }
      this.visible = false
    },
    //选择审批人左侧的删除
    onClickDelUser(index) {
      this.disableList.splice(index, 1)
    }
  },
  watch: {
    drawer(n) {
      if (!n) {
        const { originator, approver, payer, message } = this
        saveData = { originator, approver, payer, message }
      }
    },
    visible(n) {
      if(n){
        this.disableList = []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep .audit-show {
  .el-dialog__body {
    @apply p-0;
  }
  .el-dialog__footer {
    @apply pr-6 py-4 border-t border-black border-opacity-10 border-solid;
  }
  .add-audit-content {
    & div {
      @apply flex-1;
    }
  }
}
</style>
